// CLARTEXT · /abo · B2-B — hochwertige, neutrale Geräte-Rahmen für die realen
// Produkt-Screenshots. Die Screenshots selbst bleiben unverändert; der Rahmen
// dient nur der Präsentation.
//
// WICHTIG (Betreibervorgabe): keine Apple-Marke, kein Logo, keine „App-Store"-
// oder „native App"-Behauptung. Das Phone ist ein neutrales, modernes Smartphone.

export function AboBrowserMockup({ src, alt, testId, className = "", eager = false }) {
  return (
    <div className={`abo-browser ${className}`.trim()} data-testid={testId}>
      <div className="abo-browser-bar" aria-hidden="true">
        <span className="abo-browser-dots">
          <span className="abo-browser-dot" />
          <span className="abo-browser-dot" />
          <span className="abo-browser-dot" />
        </span>
        <span className="abo-browser-url">clartext.io</span>
      </div>
      <div className="abo-browser-screen">
        <img src={src} alt={alt} loading={eager ? "eager" : "lazy"} draggable="false" />
      </div>
    </div>
  );
}

// Neutraler Laptop-Rahmen für die Hero-Bildwelt: zeigt einen ECHTEN
// Produkt-Screenshot (kein erfundenes UI). Rein präsentativer CSS-Rahmen.
export function AboLaptopMockup({ src, alt, testId }) {
  return (
    <div className="abo-laptop" data-testid={testId}>
      <div className="abo-laptop-lid">
        <div className="abo-laptop-screen">
          <img src={src} alt={alt} loading="eager" draggable="false" />
        </div>
      </div>
      <div className="abo-laptop-base" aria-hidden="true">
        <span className="abo-laptop-hinge" />
      </div>
    </div>
  );
}

export function AboPhoneMockup({ src, alt, testId, eager = false }) {
  return (
    <div className="abo-phone" data-testid={testId}>
      <div className="abo-phone-frame">
        <span className="abo-phone-notch" aria-hidden="true" />
        <div className="abo-phone-screen">
          <img src={src} alt={alt} loading={eager ? "eager" : "lazy"} draggable="false" />
        </div>
      </div>
    </div>
  );
}

// Hochwertiger iMac-/Monitor-Rahmen (Device Presentation Pass 01). Zeigt einen
// ECHTEN Produkt-Screenshot als reales Softwareobjekt: All-Screen-Display mit
// dünner Blende, Alu-Kinn und Standfuß, weiche Tiefe. KEINE Apple-Marke/Logo.
// `compact` = eigene, vereinfachte Mobile-Komposition (ohne Standfuß, schlanke
// Blende), damit der Screenshot auf 390px groß und lesbar bleibt.
export function AboImacMockup({ src, alt, testId, compact = false, eager = false }) {
  return (
    <div
      className={`abo-imac${compact ? " abo-imac--compact" : ""}`}
      data-testid={testId}
    >
      <div className="abo-imac-body">
        <div className="abo-imac-glass">
          <img
            src={src}
            alt={alt}
            loading={eager ? "eager" : "lazy"}
            draggable="false"
          />
        </div>
        <div className="abo-imac-chin" aria-hidden="true" />
      </div>
      {!compact && (
        <div className="abo-imac-stand" aria-hidden="true">
          <span className="abo-imac-neck" />
          <span className="abo-imac-foot" />
        </div>
      )}
    </div>
  );
}
